import React, { PropsWithChildren } from 'react';
import { DivProps } from '../../../../types/HtmlProps';
import { appendClassName } from '../../../../lib/bemUtils/classname';
import { Modifier } from '../../../../lib/bemUtils/Modifier';
import bem from '../../../../lib/bemUtils/bem';

export enum AccordionPanelModifier {
  NO_BORDER_TOP = 'no-border-top',
}

interface AccordionPanelProps extends DivProps {
  modifier?: Modifier<AccordionPanelModifier>;
}

export function AccordionPanel({
  children,
  className,
  modifier,
  role,
  ...divProps
}: PropsWithChildren<AccordionPanelProps>) {
  return (
    <div
      {...divProps}
      className={appendClassName(className, bem('accordion__panel', modifier))}
      role={role || 'region'}
    >
      <div className="accordion__panel-content">{children}</div>
    </div>
  );
}
